import { memo } from 'react';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';

const JeeNavigationComponent = () => {
  const {
    testRes,
    updateActiveSection,
    updateActiveQuestion,
    clearQuestionResponse,
  } = useApp();

  const section = testRes.sectionList.filter(
    (section: Section) => section.active,
  )[0];

  const question = section.questionList.filter(
    (question: Question) => question.active,
  )[0];

  const handleSelect = (sectionId: string, qId: string) => {
    // If question is not saved (via SAVE & NEXT), clear it before moving
    // If question is already saved, keep it saved
    if (!question.saved) {
      clearQuestionResponse(question.id);
    }
    if (sectionId !== section.id) {
      updateActiveSection(sectionId, qId);
    } else {
      updateActiveQuestion(qId);
    }
  };

  const getQuestionStatus = (question: Question) => {
    const visited =
      question.timeTaken > 0 ||
      (question.attempted && question.saved) ||
      question.markedForRevisit ||
      question.active;

    if (!visited) return 'not-visited';
    if (question.attempted && question.saved && question.markedForRevisit)
      return 'answered-and-marked';
    if (question.attempted && question.saved) return 'answered';
    if (question.markedForRevisit) return 'marked-for-review';
    return 'not-answered';
  };

  const getButtonStyle = (question: Question, status: string) => {
    const baseStyle: React.CSSProperties = {
      width: '42px',
      height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      fontWeight: '600',
      fontSize: '14px',
      border: 'none',
      position: 'relative',
    };

    switch (status) {
      case 'not-visited':
        return {
          ...baseStyle,
          backgroundColor: '#e0e0e0',
          color: '#666',
          borderRadius: '6px',
        };
      case 'not-answered':
        return { ...baseStyle, backgroundColor: '#dc3545', color: 'white' };
      case 'answered':
        return { ...baseStyle, backgroundColor: '#28a745', color: 'white' };
      case 'marked-for-review':
      case 'answered-and-marked':
        return {
          ...baseStyle,
          backgroundColor: '#6f42c1',
          color: 'white',
          borderRadius: '50%',
        };
      default:
        return baseStyle;
    }
  };

  const formatQuestionNumber = (index: number) =>
    index.toString().padStart(2, '0');

  return (
    <div
      className="p-3"
      style={{
        width: '100%',
        maxHeight: '500px',
        overflowY: 'auto',
        overflowX: 'hidden',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px',
      }}
    >
      <div>
        {testRes.sectionList.map((_section: Section) => {
          return (
            <>
              <p
                style={{
                  fontSize: '14px',
                  fontWeight: '600',
                  marginBottom: '4px',
                }}
              >
                {_section.name.en}
              </p>
              <div
                key={_section.id}
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(50px, 1fr))',
                  gap: '8px',
                  width: '100%',
                  marginBottom: '8px',
                }}
              >
                {_section.questionList.map((question: Question) => {
                  const status = getQuestionStatus(question);
                  const buttonStyle = getButtonStyle(question, status);
                  const isActive = question.active;

                  return (
                    <button
                      key={question.id}
                      style={{
                        ...buttonStyle,
                        ...(isActive && {
                          outline: '2px solid #007bff',
                          outlineOffset: '1px',
                        }),
                      }}
                      onClick={() => handleSelect(_section.id, question.id)}
                    >
                      {formatQuestionNumber(question.index)}

                      {status === 'answered-and-marked' && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '4px',
                            right: '4px',
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#28a745',
                            borderRadius: '2px',
                          }}
                        />
                      )}
                    </button>
                  );
                })}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default memo(JeeNavigationComponent);
